import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { secureStorage } from 'services/secure-storage.service';

const SAMLCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const data = params.get('data');

        if (!data) {
          console.error('No data received in SAML callback');
          navigate('/authentication/sign-in');
          return;
        }

        const userData = JSON.parse(decodeURIComponent(data));

        // Guardar datos del usuario
        secureStorage.setItem('user', JSON.stringify(userData));

        // Asignar avatar basado en los roles
        const avatar = userData.roles.includes('SYSTEMADMIN')
          ? 'avatar1'
          : userData.roles.includes('OPSADMIN')
          ? 'avatar2'
          : userData.roles.includes('QAADMIN')
          ? 'avatar3'
          : userData.roles.includes('QAMEMBER')
          ? 'avatar4'
          : 'avatar5';

        secureStorage.setItem('avatar', avatar);

        // Redireccionar según el rol
        // eslint-disable-next-line
        const redirectPath = avatar === 'avatar1' ? '/system-management/system-dashboard' : '/';

        navigate(redirectPath);
      } catch (error) {
        console.error('Error processing SAML callback:', error);
        // Mostrar mensaje de error y redireccionar al login
        navigate('/authentication/sign-in', {
          state: {
            error: 'Error processing SAML login. Please try again.',
            showError: true
          }
        });
      }
    };

    handleCallback();
  }, [navigate]);

  // Mostrar un spinner o mensaje de carga mientras se procesa
  return (
    <div className="text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-2">Processing login...</p>
    </div>
  );
};

export default SAMLCallback;
